import request from '../utils/request'


export function index(params) {
  return request({
    url: '/injuryStatuses',
    method: 'get',
      params
  })
}

export function inventory(params) {
  return request({
    url: '/injuryStatuses/inventory',
    method: 'get',
    params
  })
}

  

export function show(id) {
    return request({
      url: `/injuryStatuses/${id}`,
      method: 'get'
    })
  }

  export function store(data) {
    return request({
      url: '/injuryStatuses',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/injuryStatuses/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/injuryStatuses/${id}`,
      method: 'delete',
    })
  }
